import { render } from "./MTextField.vue?vue&type=template&id=45aa2124"
import script from "./MTextField.vue?vue&type=script&lang=ts"
export * from "./MTextField.vue?vue&type=script&lang=ts"
script.render = render

export default script